module.exports = __webpack_public_path__ + "img/phoenix.2e7d91ea.png";